import { ChartTableReportComponentProperties } from '../chart-table/chart-table.report.component.interface';

export const CHART_QUALITY_SCORE_CONFIGS: ChartTableReportComponentProperties[] = [
	{
		tabId: 'overall.qualityScore',
		chartHeader: 'OVERALL QUALITY SCORE',
		chartHeaderDcr: 'OVERALL_QUALITY_SCORE',
		description: 'ESG Score'
	} as ChartTableReportComponentProperties, {
		tabId: 'environment.pillarScore',
		chartHeader: 'ENVIRONMENTAL PILLAR SCORE',
		chartHeaderDcr: 'ENVIRONMENTAL_PILLAR_SCORE',
		description: 'Env. Pillar Score'
	} as ChartTableReportComponentProperties, {
		tabId: 'social.pillarScore',
		chartHeader: 'SOCIAL PILLAR SCORE',
		chartHeaderDcr: 'SOCIAL_PILLAR_SCORE',
		description: 'Social Pillar Score'
	} as ChartTableReportComponentProperties, {
		tabId: 'governance.pillarScore',
		chartHeader: 'GOVERNANCE PILLAR SCORE',
		chartHeaderDcr: 'GOVERNANCE_PILLAR_SCORE',
		description: 'Governance Pillar Score'
	} as ChartTableReportComponentProperties];

export const CHART_CARBON_EMISSIONS_CONFIG: ChartTableReportComponentProperties[] = [
	{
		tabId: 'esg.carbonIntensity',
		chartHeader: 'CARBON EMISSIONS INTENSITY',
		chartHeaderDcr: 'CARBON_EMISSIONS_INTENSITY',
		description: 'Carbon Emissions Intensity'
	} as ChartTableReportComponentProperties
];
